import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { AuthenticationService } from '../../_services/authentication.service'
import { environment } from '../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class RequestsService {
  constructor(private http: HttpClient) {}

  getParams(params) {
    return new HttpParams({ fromObject: params })
  }

  post(endpoint: string, data: object): Observable<any> {
    return this.http.post(`${environment.API_URL}/${endpoint}`, { ...data })
  }

  postNotification(notifiObject: object, notfiApp: string): Observable<any> {
    return this.http.post(
      `${environment.DASH_API_URL}/dashboard/notification?ezyapp=${notfiApp}`,
      { ...notifiObject }
    )
  }

  resendNotification(notificationResend: object): Observable<any> {
    return this.http.post(
      `${environment.DASH_API_URL}/dashboard/notification-resend`,
      { ...notificationResend }
    )
  }

  notificationGet(): Observable<any> {
    return this.http.get(
      `${environment.DASH_API_URL}/dashboard/notification-fetch`
    )
  }

  creditAggPost(endpoint: string, data: any): Observable<any> {
    return this.http.post(
      `${environment.CREDIT_AGG}/api/v3/${endpoint}`,
      data,
    )
  }

  get(endpoint: string, params: any): Observable<any> {
    return this.http.get(`${environment.API_URL}/${endpoint}`)
  }
  dash_get(endpoint: string, params: any, v2 = false): Observable<any> {
    return this.http.get(
      `${v2 ? environment.API_URL_V2 : environment.DASH_API_URL}/${endpoint}`
    )
  }

  dash_get3(endpoint: string, params: any, v2 = false): Observable<any> {
    return this.http.get(
      `${v2 ? environment.API_URL_V3 : environment.DASH_API_URL}/${endpoint}`
    )
  }
  // Function below to be removed
  dash_post(
    endpoint: string,
    data: any,
    v2 = false,
    options = {}
  ): Observable<any> {
    return this.http.post(
      `${v2 ? environment.API_URL_V2 : environment.DASH_API_URL}/${endpoint}`,
      data,
      options
    )
  }

  dashboard_fetch(
    endpoint: string,
    data: any,
    options = {}
  ): Observable<any> {
    return this.http.post(
      `${environment.API_URL_V3}/${endpoint}`,
      data,
      options
    )
  }

  dash_put(endpoint: string, data: object, v2 = false): Observable<any> {
    return this.http.put(
      `${v2 ? environment.API_URL_V2 : environment.DASH_API_URL}/${endpoint}`,
      {
        ...data,
      }
    )
  }
  prof_post(endpoint: string, data: any): Observable<any> {
    return this.http.post(
      `${environment.PROF_API}/${endpoint}`,
      data,
    )
  }

  dash_patch(endpoint: string, data: object, v2 = false): Observable<any> {
    return this.http.patch(
      `${v2 ? environment.API_URL_V2 : environment.DASH_API_URL}/${endpoint}`,
      {
        ...data,
      }
    )
  }
  dash_delete(id: string, endpoint: string, v2 = false): Observable<any> {
    return this.http.delete(
      `${
        v2 ? environment.API_URL_V2 : environment.DASH_API_URL
      }/${endpoint}/${id}`
    )
  }
  dash_putWithImage(endpoint: string, data: any, v2 = false): Observable<any> {
    return this.http.post(
      `${v2 ? environment.API_URL_V2 : environment.DASH_API_URL}/${endpoint}`,
      data
    )
  }
  patch(endpoint: string, id: string, data: object): Observable<any> {
    return this.http.patch(`${environment.API_URL}/${endpoint}/${id}`, {
      ...data,
    })
  }
  put(endpoint: string, data: object): Observable<any> {
    return this.http.put(`${environment.API_URL}/${endpoint}`, {
      ...data,
    })
  }

  delete(id: string, endpoint: string): Observable<any> {
    return this.http.delete(`${environment.API_URL}/${endpoint}/${id}`)
  }

  putWithImage(endpoint: string, data: any): Observable<any> {
    return this.http.post(`${environment.API_URL}/${endpoint}`, data)
  }

  notifyPost(endpoint: string, data: any): Observable<any> {
    return this.http.post(`${environment.NOTIFY_API}${endpoint}`, data)
  }
  // notifyGet(endpoint: string, params: HttpParams ): Observable<any> {
  //   return this.http.get(`${environment.NOTIFY_API}${endpoint}`,{ params })
  // }
  notifyGet(endpoint: string,): Observable<any> {
    return this.http.get(`${environment.NOTIFY_API}${endpoint}`)
  }

}
